// Calendario de Gestores: los días de la semana y los colores de los organismos, que comparten la lista, el formulario y la matriz.

// Los valores son los mismos que guarda el backend (1 = lunes ... 5 = viernes, como DayOfWeek de .NET).
export const DIAS = [
  { valor: 1, nombre: "Lunes" },
  { valor: 2, nombre: "Martes" },
  { valor: 3, nombre: "Miércoles" },
  { valor: 4, nombre: "Jueves" },
  { valor: 5, nombre: "Viernes" },
];

export const nombreDia = (valor) => DIAS.find((d) => d.valor === valor)?.nombre ?? "";

// Un color por organismo, siempre el mismo para el mismo organismo (sale de su ID): así se lo reconoce de un vistazo en la matriz.
// Fondo y color de texto elegidos para que se lea bien. Los colores solo se repiten si hay más organismos que colores.
// Los primeros 12 son los del calendario en papel; los 24 siguientes se eligieron lo más distintos posible entre sí y de los colores
// reservados de la pantalla (blanco de las celdas vacías, verde y amarillo del encabezado y el gris de «varios organismos»), y vienen
// en un orden que separa a los organismos con IDs seguidos. Si se agrega uno, mantener contraste de texto de 4,5 o más.
const PALETA = [
  { fondo: "#f4c7c3", texto: "#3b1d1a" },
  { fondo: "#f6c244", texto: "#3b2a00" },
  { fondo: "#8fbf7f", texto: "#10260b" },
  { fondo: "#ffff00", texto: "#2b2b00" },
  { fondo: "#a64d79", texto: "#ffffff" },
  { fondo: "#00ff00", texto: "#003300" },
  { fondo: "#cc4125", texto: "#ffffff" },
  { fondo: "#e06666", texto: "#2b0a0a" },
  { fondo: "#a4c2f4", texto: "#0b1f44" },
  { fondo: "#d9d2e9", texto: "#241a40" },
  { fondo: "#76a5af", texto: "#0a2a30" },
  { fondo: "#f9cb9c", texto: "#3b2108" },
  { fondo: "#345bc9", texto: "#ffffff" },
  { fondo: "#786118", texto: "#ffffff" },
  { fondo: "#f491fe", texto: "#141414" },
  { fondo: "#067403", texto: "#ffffff" },
  { fondo: "#02e6c3", texto: "#141414" },
  { fondo: "#94aa23", texto: "#141414" },
  { fondo: "#416d45", texto: "#ffffff" },
  { fondo: "#983ba4", texto: "#ffffff" },
  { fondo: "#097dbe", texto: "#ffffff" },
  { fondo: "#9b7ec5", texto: "#141414" },
  { fondo: "#2be0f4", texto: "#141414" },
  { fondo: "#62e587", texto: "#141414" },
  { fondo: "#e18c4c", texto: "#141414" },
  { fondo: "#8d5442", texto: "#ffffff" },
  { fondo: "#fc98bd", texto: "#141414" },
  { fondo: "#ef4f8e", texto: "#141414" },
  { fondo: "#0da063", texto: "#141414" },
  { fondo: "#f1b8ff", texto: "#141414" },
  { fondo: "#aca254", texto: "#141414" },
  { fondo: "#759eff", texto: "#141414" },
  { fondo: "#9d4d16", texto: "#ffffff" },
  { fondo: "#a075e7", texto: "#141414" },
  { fondo: "#c01a49", texto: "#ffffff" },
  { fondo: "#88dbc7", texto: "#141414" },
];

export const colorOrganismo = (idOrganismo) => PALETA[Math.abs(Number(idOrganismo) || 0) % PALETA.length];

// Varios organismos el mismo día (por ejemplo, «Oncativo / Pilar») van en un color propio que ningún organismo usa: gris azulado oscuro,
// fuera de la PALETA (que es toda de colores claros o vivos). Si se agrega un color a la PALETA, que no sea parecido a este.
export const COLOR_VARIOS = { fondo: "#455a64", texto: "#ffffff" };

// ID del día de hoy en el calendario (1 = lunes ... 5 = viernes); 0 si es sábado o domingo.
export const diaDeHoy = () => {
  const hoy = new Date().getDay();
  return hoy >= 1 && hoy <= 5 ? hoy : 0;
};
